import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
const swal = require('sweetalert');
import { PayoutService } from 'src/app/services/payout.service';
import * as XLSX from 'xlsx';
import { Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { TransactionService } from 'src/app/services/transaction/transaction.service';
@Component({
  selector: 'app-pay-out-bulk-upload-files',
  templateUrl: './pay-out-bulk-upload-files.component.html',
  styleUrls: ['./pay-out-bulk-upload-files.component.scss']
})
export class PayOutBulkUploadFilesComponent implements OnInit {
  uploadfile:boolean=false;
  invalidfile:boolean=false;
  Tourtransaction:any;
  getinfo:any;
  sMsg: string = '';
  UploadFilebutton:boolean=false;
  myFiles: string[] = [];
  isUploadFile: boolean = false;
  excelTansactionDataResponse = [];
  excelTranStatus: any;
  Rfromdate: boolean = false;
  isreportsbtnActive: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  BulkFileId = new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);
  filtering: boolean = false;
  Dfiltering: boolean = true;
  fromdate = new FormControl("", [Validators.required]);
  Amount = new FormControl("", [Validators.required]);
  //   Fromdate1 = new Date();
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  Status = new FormControl("", [Validators.required]);
  amountcheck = new FormControl("", [Validators.required]);
  symbol = [
    { text: "=", value: "=" },
    { text: "<", value: "<" },
    { text: ">", value: ">" },
    { text: "<=", value: "<=" },
    { text: ">=", value: ">=" },
    { text: "<>", value: "<>" },

  ];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  editing = {};
  row = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  loggedinuseremail:any;
  MerchantKeyId:any;
  Workclose= false;
  bulkuploadStep1 = true;
    bulkuploadStep2 = false;
    bulkuploadTour= true;
    tourDiv= false;
  constructor(private commonfunction: CommonFunctionService, private transactionservice: TransactionService,
    private service: PayoutService,private router: Router) { }

  ngOnInit() {
    this.getPayOutBulkUploadFileList();
    this.getUserPermissions();

    this.getinfo=localStorage.getItem('SettingDetails')
    var Transaction=this.getinfo;
    let jsonObj: any = JSON.parse(this.getinfo);
    
    if(jsonObj !=null)
    {
   this.Tourtransaction=jsonObj.ProductKnowledgeGuide_ProductTourBulkPayments;
   if(this.Tourtransaction ==false)
   {
     this.SkipTour();
   }
  }
  }
  getPayOutBulkUploadFileList()
  {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
    this.PayOutBulkUploadFile((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.row = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);

    });
  }
  PayOutBulkUploadFile(cb) {
    const req = new XMLHttpRequest();
    // req.open('GET', environment.getPayOutBulkUploadFileList + "?MerchantKeyId=" + this.MerchantKeyId + "&UserId="+this.loggedinuseremail);
   
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
    this.service.getPayOutBulkUploadFileList(this.MerchantKeyId,this.loggedinuseremail).subscribe(data => {
    if(data !=null)
    {
          this.temp = _clone(data);
      this.row = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
    }
  });
  }


  filters() {
    this.filtering = !this.filtering;
  }

  close(){
    this.Workclose= false;
}
Nextstep() {
  this.bulkuploadStep1 = false;
  this.bulkuploadStep2 = true;
  this.bulkuploadTour = false;
  this.tourDiv= true;

}

GetStarted() {
  this.bulkuploadStep2 = false; 
  this.bulkuploadTour = true;
  this.tourDiv = false;
  this.bulkuploadStep1 = false;
}
backSubmit() {
  this.bulkuploadStep1 = true;
  this.bulkuploadStep2 = false;
  this.bulkuploadTour = false;
  this.tourDiv = true;

}
GotoTour(){
  this.tourDiv = true; 
  this.bulkuploadTour = false;
  this.bulkuploadStep2 = false;
  this.bulkuploadStep1 = true;

}
SkipTour(){
  this.tourDiv = false; 
  this.bulkuploadTour = true;
  this.bulkuploadStep2 = false;
  this.bulkuploadStep1 = false;
}
  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
       this.search();

    }
  }



  search() {
    this.PayOutBulkUploadFileFilterData((data) => {
      // cache our list
     
     
    });

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }


  checkRangeType()
  {
    var daterange=this.daterange.value;
    if(daterange=="Custom Date Range")
    {
     this.isCustomDateSelected = true;
     this.isStartDateGreaterthenEndDate = false;
        this.Rfromdate=true;
       this. Dfiltering=false;
       this.fromdate.setValue('');
       this.todate.setValue('');
       this.isreportsbtnActive = false;
    }
    else{
     this.isCustomDateSelected = false;
     this.isStartDateGreaterthenEndDate = false;
     this.Rfromdate=false;   
    }
  }
  





  PayOutBulkUploadFileFilterData(cb) {
    var daterange = this.daterange.value;
    var FileId = this.BulkFileId.value;
    var Status = this.Status.value;
if(FileId=="")
{
  FileId="0";
}
    var Amount = this.Amount.value;
    var amountcompare = this.amountcheck.value;
    if (Amount == "") {
      Amount = "0";
    }
    if(Status=="")
    {
      Status="0";
    }
  
    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = '01/01/1990';
      this.todate1 = new Date().toISOString().slice(0, 10);
    }
   
    // const req = new XMLHttpRequest();
    // req.open('GET',
    //   environment.Getbulkuploaddataurl + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&Id=" + FileId
    //   + "&Status=" + Status + "&Amount=" + Amount + "&AmountCheck=" + amountcompare );
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
    
    // req.send();
   // this.service.Getbulkuploaddataurl(this.MerchantKeyId,this.Fromdate1,this.todate1,FileId,Status,Amount,amountcompare).subscribe(data => {
      let form = {
        MerchantKeyId:this.MerchantKeyId,
        fromdate:this.Fromdate1, 
        todate:this.todate1,
        FileId:FileId,
        Status:Status,
        AmountCheck:amountcompare,
        Amount:Amount
        };
      this.service.Getbulkuploaddataurl(form).subscribe(data => {
    if(data !=null)
    {
      this.temp = _clone(data);
      this.row = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
    }
  });
  }
  






  
  readAndExportTransactionData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.row.length > 0) {
      this.row.forEach(element => {
        var manageTranArray = { 'PayOut Bulk FileId': element.PayOutBulkFileId, 'Total Amount': element.TotalAmount, 'Total Record Count': element.TotalRecordCount, 'FileName': element.FileName, 'Status': element.Status, 'Date Time': element.LastUpdateDateTime}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse, { header: ['PayOut Bulk FileId', 'Total Amount', 'Total Record Count', 'FileName', 'Status', 'Date Time'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }




  
  DownLoadTransactionData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse, { header: ['Payout Customer keyId', 'PayOut Beneficiary KeyId', 'Amount', 'PaymentType', 'MerchantKeyId', 'Note'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');

    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.csv');
    this.excelTansactionDataResponse = [];
  }






  getFileDetails(e) {
    this.invalidfile=false;;
    for (var i = 0; i < e.target.files.length; i++) {
      this.myFiles.push(e.target.files[i]);
      var type=e.target.files[i].name.split('.')[1];
      if(type !="csv" && type !="Csv")
      {
        this.invalidfile=true;
      }
    }

    if (this.myFiles.length != null) {
      this.isUploadFile = true;
      this.UploadFilebutton = true;
    }
    else {
      this.isUploadFile = true;
    }
  }


  
  uploadFiles() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    // form.UpdatedUserName = this.commonfunction.getUserId();
    this.MerchantKeyId = merchantdata.MerchantKeyId;
    const frmData = new FormData();
    // this.businessId = this.businessId;

    for (var i = 0; i < this.myFiles.length; i++) {
      frmData.append("fileUpload", this.myFiles[i]);
    }
    this.service.FileUpload(frmData,this.MerchantKeyId).subscribe(data => {
        if(data !=null)
        {
      if(data=="Invalid Details")
      {
        this.sMsg = data as string;
        swal("Error", "Invalid Details", "error");
      }
      else if(data=="Fill the details")
      {
        this.sMsg = data as string;
        swal("Error", "uploaded file should not be empty", "error");
      }
      else{
        this.sMsg = data as string;
        swal("Added", "File Uploaded Successfully", "success");
        this.openConfirmationDialog();
      }
          
          
        
        }
       
        // this.getAccountDatasList();
      });
    // this._router.navigate(['/home/addonBusiness/manage-business-account-data',{id :this.businessId}]);

    this.isUploadFile = false;
  }



  


  openConfirmationDialog() {
    
    swal({
      title: 'File Uploaded Successfully',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  
  }


  ShowMeAgain()
  {
    var Type="Bulk Upload";
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.transactionservice.UpdateManageTransactionSettings(merchantdata.MerchantKeyId,merchantdata.UserId,Type).subscribe(result => {
      if(result !=null)
      {
        localStorage.removeItem('SettingDetails');
        this.transactionservice.GetUserPreferenceSettings(merchantdata.MerchantKeyId,merchantdata.UserId).subscribe(result => {
          if(result !=null)
          {
           localStorage.setItem("SettingDetails",JSON.stringify(result));
           window.location.reload();
          }
        });
      }
    });
  }
  getUserPermissions() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
      if (result != null) {
        for (var i in result) {
          if (result[i].UserPermission == 'PayOut') {
            var type = result[i].Type;
            if (type == 'R') 
            {
               
                this.uploadfile=false;
            
            }
           else if (type == 'RW') 
            {
              this.uploadfile=true;
            }
           else if (type == 'RWD') 
            {
              this.uploadfile=true;
            }
          }
        }
  
      }
  
    });
  }
  resetForm(){

    this.daterange.reset('');
    this.Amount.reset(''); 
    this.amountcheck.reset('');
    this.row=[];
    
    
  
   
  
  }

}
